export interface LoadingDialogConfiguration {
    label: string;
    closeCallback?: () => void;
    value?: number | string;
}

export interface QrDialogConfiguration {
    title: string;
    url: string;
    buttons?: Array<DialogSimpleButton>;
}

type InputDialogBaseButtonCallback =
    (() => void) |
    ((value?: string) => void) |
    ((value: string) => void);

interface InputDialogBaseButtonProps {
    label: string;
    key: string;
    checkInput?: boolean;
    preventCloseCall?: boolean;
}

export interface DialogSimpleButton {
    label: string;
    callback: () => void;
}

export type InputDialogBaseDefaultButton = InputDialogBaseButtonProps & {
    type?: 'click';
    callback?: InputDialogBaseButtonCallback;
};

type InputDialogBaseLinkButton = InputDialogBaseButtonProps & {
    type: 'link';
    href: string;
    download?: string;
};

export type InputDialogBaseButton = InputDialogBaseDefaultButton | InputDialogBaseLinkButton;

export function isLinkButton(value: InputDialogBaseButton): value is InputDialogBaseLinkButton {
    return value.type === 'link';
}